export { default } from './MultipleChoice.js';
